/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialListQuery
 */
export interface ProviderCredentialListQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof ProviderCredentialListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialListQuery
     */
    provider?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialListQuery
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProviderCredentialListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProviderCredentialListQuery
     */
    limit?: number | null;
}

export function ProviderCredentialListQueryFromJSON(json: any): ProviderCredentialListQuery {
    return ProviderCredentialListQueryFromJSONTyped(json, false);
}

export function ProviderCredentialListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function ProviderCredentialListQueryToJSON(value?: ProviderCredentialListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'provider': value.provider,
        'showNonEffective': value.showNonEffective,
        'offset': value.offset,
        'limit': value.limit,
    };
}


